import {
  emptyResponseSchema,
  workspaceResponseSchema,
  workspacesResponseSchema,
  type CreateWorkspaceRequest,
  type UpdateWorkspaceInput,
  type WorkspaceWithRole,
} from "@tm/contracts";
import { apiRequest } from "./client";

const base = (workspaceId: string) => `/workspaces/${encodeURIComponent(workspaceId)}`;

export const workspacesApi = {
  async list(signal?: AbortSignal): Promise<WorkspaceWithRole[]> {
    const { workspaces } = await apiRequest("/workspaces", {
      schema: workspacesResponseSchema,
      signal,
    });
    return workspaces;
  },

  async create(input: CreateWorkspaceRequest): Promise<WorkspaceWithRole> {
    const { workspace } = await apiRequest("/workspaces", {
      method: "POST",
      body: input,
      schema: workspaceResponseSchema,
    });
    return workspace;
  },

  async update(workspaceId: string, input: UpdateWorkspaceInput): Promise<WorkspaceWithRole> {
    const { workspace } = await apiRequest(base(workspaceId), {
      method: "PATCH",
      body: input,
      schema: workspaceResponseSchema,
    });
    return workspace;
  },

  async remove(workspaceId: string): Promise<void> {
    await apiRequest(base(workspaceId), { method: "DELETE", schema: emptyResponseSchema });
  },

  async transferOwnership(workspaceId: string, userId: string): Promise<WorkspaceWithRole> {
    const { workspace } = await apiRequest(`${base(workspaceId)}/transfer-ownership`, {
      method: "POST",
      body: { userId },
      schema: workspaceResponseSchema,
    });
    return workspace;
  },
};
